import React, { Component } from 'react'
import { TextField } from '@material-ui/core';

class TextInputFieldControlled extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: this.props.type,
            label: this.props.label,
            helperText: this.props.helperText,
            name: this.props.name,
            pattern: this.props.pattern,
            placeholder: this.props.placeholder,
            required: this.props.required,
            autoComplete: this.props.autoComplete,
            onChangeParent: this.props.onChangeParent,
            saveResponse: this.props.saveResponse,
            valueType: this.props.valueType,
            value: this.props.value
        }

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.setState({
            value: e.target.value,
        });
    }

    render() {      
        return (
            <TextField 
                id="outlined-basic" 
                label={this.state.label}
                variant="outlined"
                name={this.state.name}
                placeholder={this.state.placeholder}
                required={this.state.required}
                autoComplete={this.state.autoComplete}
                onChange={this.onChange}
                data-save={this.state.saveResponse}
                data-value-type={this.state.valueType}
                value={this.state.value}
                helperText={this.state.helperText}
                inputProps={this.state.pattern ? {'pattern': this.state.pattern} : {}}
            />
        );
    }
}

export default TextInputFieldControlled
